const Skill = () => {
    return (
        <main className="section">
            <div className="container">
                <h1 className="title-1">Skills</h1>

                <ul className="content-list">
                    <li claclassNamess="content-list__item">
                        <h2 className="title-2">Frontend</h2>
                        <p>JavaScript, TypeScript, ReactJS, Redux, HTML, CSS, NPM, BootStrap</p>
                    </li>
                </ul>

            </div>
        </main>
    )
}

export default Skill;